import React from 'react';
import PropTypes from 'prop-types';

function TaxTable({
  title,
  note,
  taxableRows,
  summaryRows,
  currencySymbol,
}) {
  const rowSpacingClass = 'mb-2 mt-2';

  const renderHeaderRow = (noteData) => (
    <div className="full-group border-bottom">
      <div className="form-row">
        <div className="form-input-group col-12 col-md-6">
          <label className="full-label mb-2">{noteData}</label>
        </div>
        <div className="form-input-group col-12 col-md-3 d-flex justify-content-center">
          <label
            htmlFor="height"
            className="full-label mb-0 text-secondary"
          >
            TAXABLE AMOUNT
          </label>
        </div>
        <div className="form-input-group col-12 col-md-3 d-flex justify-content-center">
          <label
            htmlFor="height"
            className="full-label mb-0 text-secondary"
          >
            CEDULA AMOUNT
          </label>
        </div>
      </div>
    </div>
  );

  const renderTaxableRow = (row, keyPrefix) => (
    <div className="full-group border-bottom" key={`${keyPrefix}-${row.key}`}>
      <div className="form-row">
        <div className="form-input-group col-12 col-md-6 border-right">
          <label htmlFor="profession" className={`full-label ${rowSpacingClass}`}>
            {row.label}
          </label>
        </div>
        <div className="form-input-group col-12 col-md-3 border-right">
          <span className={`full-input d-flex justify-content-end ${rowSpacingClass}`}>
            {row.taxableAmount}
          </span>
        </div>
        <div className="form-input-group col-12 col-md-3">
          <span className={`full-input d-flex justify-content-end ${rowSpacingClass}`}>
            {row.cedulaAmount}
          </span>
        </div>
      </div>
    </div>
  );

  const renderSummaryRow = (row, keyPrefix) => (
    <div
      className={`full-group border-bottom ${row.isTotal ? 'font-weight-bold' : ''}`}
      key={`${keyPrefix}-${row.key}`}
    >
      <div className="form-row">
        <div className="form-input-group col-12 col-md-6 border-right d-flex justify-content-end">
          <label className={`full-label ${rowSpacingClass}`}>
            {row.label}
          </label>
        </div>
        <div className="form-input-group col-12 col-md-3 border-right">
          <span className={`full-input d-flex justify-content-end ${rowSpacingClass}`}>
            &nbsp;
          </span>
        </div>
        <div className="form-input-group col-12 col-md-3">
          <span className={`full-input d-flex justify-content-end ${rowSpacingClass}`}>
            {currencySymbol} {row.cedulaAmount}
          </span>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div>
        {title ? <h6 className="text-secondary mb-2">{title}</h6> : null}
        <div>
          {renderHeaderRow(note)}
          {taxableRows.map((row) => renderTaxableRow(row, 'taxable'))}
          {summaryRows.map((row) => renderSummaryRow(row, 'summary'))}
        </div>
      </div>
    </>
  );
}

TaxTable.defaultProps = {
  title: '',
  note: '',
  taxableRows: [],
  summaryRows: [],
  currencySymbol: '\u20B1',
};

TaxTable.propTypes = {
  title: PropTypes.string,
  note: PropTypes.string,
  currencySymbol: PropTypes.string,
  taxableRows: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.string,
      taxableAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      cedulaAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    })
  ),
  summaryRows: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.string,
      cedulaAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      isTotal: PropTypes.bool,
    })
  ),
};

export default TaxTable;
